import type { ReduxAction } from '@app/types';

export interface PublicProfileState {
  slug: string;
  enabled: boolean;
}

const initialPublicProfileState: PublicProfileState = {
  slug: '',
  enabled: false,
};

export function publicProfileReducer(
  state: PublicProfileState = initialPublicProfileState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_PUBLIC_PROFILE_REQUESTED':
      return state;
    case 'FETCH_PUBLIC_PROFILE_SUCCEEDED':
    case 'UPDATE_PUBLIC_PROFILE_SUCCEEDED':
      return {
        slug: payload.response.slug,
        enabled: payload.response.is_active ?? false,
      };
    case 'FETCH_PUBLIC_PROFILE_FAILED':
      return {
        slug: undefined,
        enabled: false,
      };
    case 'DELETE_PUBLIC_PROFILE_SUCCEEDED':
      return {
        ...state,
        enabled: false,
      };
    default:
      return state;
  }
}
